import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import iconEmpty from 'icons/createproject/supportneed.svg'
import {
  Button,
  Drawer,
  Form,
  Row,
  Col,
  Input,
  Select,
  DatePicker,
  Table,
  Space,
  Alert,
  Modal,
  Switch,
} from 'antd'
//checkrole
import { CounterContext } from 'redux/Golbalvalues'
import { PlusOutlined, SearchOutlined, RedoOutlined } from '@ant-design/icons'
import moment, { months } from 'moment'
import DeleteUnitMeasurment from 'common/Management/delete'
import {
  getDataUnitmeasurment,
  addUnitmeasuement,
  updateUnitmeasurment,
  getDataUnitmeasurmentV2,
} from 'api/Admin/unitmeasurment'
import { getCookie } from 'helper/cookie'
import { set, toUpper } from 'lodash'
import lang from 'lang/en'
import '../../../styleLess/signature/management.scss'
const UnitContainer = styled.div``
const EmptyContainer = styled.div``
const ContainerMeasurment = styled.div``
const Header = styled.div``
const Body = styled.div``
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
`
const ModalCenter = styled.div`
  background-color: coral;
`

const initalState = {
  data: [],
  isLoading: true,
  pagination: {
    pageSize: 10, //จำนวนข้อมูลในหน้านั้น
    total: 0, //ข้อมูลทั้งหมด
    current: 1,
    showQuickJumper: 1,
    // showSizeChanger: true,
    // showTotal: (total, range) => showToalPagination(total, range),
  },
}
let wordError = ''
const showToalPagination = (total, range) => {
  return <p className="small-show-total">{`${range[0]}-${range[1]} of ${total}`}</p>
}
const Unitmeasurement = (props) => {
  const { infoUser, today } = props
  const token = getCookie('access_token_admin')
  const language = getCookie('lang')
  const word = lang[language]
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [dataUnitMeasurment, setDataUnitMeasurment] = useState(initalState.data)
  const [visible, setVisible] = useState(false)
  const [stateDrawer, setStateDrawer] = useState('')
  const [titleDrawer, setTitleDrawer] = useState('')
  const [visibleDelete, setVisibleDelete] = useState(false)
  const [dataEdit, setDataEdit] = useState()
  const [searchText, setSearchText] = useState('')
  const [searchedColumn, setSearchedColumn] = useState('')
  const [pagination, setPagination] = useState(initalState.pagination)
  // เช็คไอดีซ้ำ
  const [hiddenError, setHiddenError] = useState(true)
  const [form] = Form.useForm()

  //checkrole
  const { adminPermission } = useContext(CounterContext)
  //check permission
  const [disablePage, setDisablePage] = useState(false)

  const [permissionPage, setPermissionPage] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  })

  const [statusActive, setStatusActive] = useState(true)

  const roleUser = getCookie('roleUser')

  useEffect(() => {
    if (roleUser == 1) {
      setPermissionPage((prevState) => ({
        ...prevState,
        create: true,
        read: true,
        update: true,
        delete: true,
      }))
    } else {
      adminPermission?.map((item) => {
        if (item.menu_id == 10) {
          setPermissionPage((prevState) => ({
            ...prevState,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
        }
      })
    }
  }, [adminPermission])

  const getResultDataUnitMeasurment = async () => {
    await getDataUnitmeasurmentV2({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataUnitMeasurment([])

          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataUnitMeasurment(data.result)
          setIsLoading(false)
          if (data.length <= 10) {
            setPagination(false)
          } else {
            setPagination(initalState.pagination)
          }
        } else {
          setDataUnitMeasurment([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataUnitMeasurment([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      getResultDataUnitMeasurment()
    }
  }, [token])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            className="mini-search-btn-admin"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          >
            <SearchOutlined className="icon" />
            {word['Search']}
          </Button>
          <Button
            type="primary"
            className="mini-search-btn-admin-reset"
            onClick={() => handleReset(clearFilters)}
          >
            {word['Reset']}
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    render: (text) => (searchedColumn === dataIndex ? text : text),
  })

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm()
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }
  const dataSource = dataUnitMeasurment.map((item) => ({
    id: item.id,
    unit_code: item.code,
    local_name: item.name,
    english_name: item.name_en,
    abbr_name: item.abbr,
    create_date: moment(item.created_at).format('L'),
    status: item.status,
    data: item,
  }))

  const columns = [
    {
      title: <h5>{word['Unit_code']}</h5>,
      dataIndex: 'unit_code',
      sorter: (a, b) => a.unit_code.localeCompare(b.unit_code),
      width: 140,
      ellipsis: true,
      ...getColumnSearchProps('unit code'),
    },
    {
      title: <h5>{word['Local_name']}</h5>,
      dataIndex: 'local_name',
      width: 180,
      sorter: (a, b) => a.local_name.localeCompare(b.local_name),
      ellipsis: true,
      ...getColumnSearchProps('local name'),
    },
    {
      title: <h5>{word['English_name']}</h5>,
      dataIndex: 'english_name',
      width: 180,
      sorter: (a, b) => a.english_name.localeCompare(b.english_name),
      ellipsis: true,
      ...getColumnSearchProps('english name'),
    },
    {
      title: <h5>{word['ABBR_name']}</h5>,
      dataIndex: 'abbr_name',
      width: 180,
      sorter: (a, b) => a.abbr_name.localeCompare(b.abbr_name),
      ellipsis: true,
      ...getColumnSearchProps('abbr name'),
    },
    {
      title: <h5>{word['Status']}</h5>,
      dataIndex: 'status',
      width: 100,
      sorter: (a, b) => a.status.localeCompare(b.status),
      ellipsis: true,
      ...getColumnSearchProps('status'),
    },
  ]
  function onChange(pagination2, filters, sorter, extra) {
    if (pagination !== false) {
      setPagination((prevState) => {
        return {
          ...prevState,
          pageSize: pagination2.pageSize,
          current: pagination2.current,
        }
      })
    }
  }
  const onChangeUnitCode = (event) => {
    form.setFieldsValue({
      unitCode: event.target.value.replace(/\s/g, ''),
    })
  }
  const onFinish = (value) => {
    if (stateDrawer === 'add') {
      const data = {
        code: value.unitCode,
        name: value.localName,
        name_en: value.engName,
        abbr: value.ABBR,
        status: statusActive ? 'Active' : 'Inactive',
      }
      try {
        addUnitmeasuement({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setHiddenError(true)
            getResultDataUnitMeasurment()
            setVisible(false)
          } else {
            if (res.data.errorCode === '2008') {
              wordError = word['err_unit_code']
            } else {
              wordError = 'error'
              console.log('wordError', wordError)
            }
            setHiddenError(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else {
      const data = {
        id: dataEdit.id,
        code: value.unitCode,
        name: value.localName,
        name_en: value.engName,
        abbr: value.ABBR,
        status: statusActive ? 'Active' : 'Inactive',
      }
      try {
        updateUnitmeasurment({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setHiddenError(true)
            getResultDataUnitMeasurment()
            setVisible(false)
            setStatusActive(true)
          } else {
            if (res.data.errorCode === '2008') {
              wordError = word['err_unit_code']
            } else {
              wordError = 'error'
            }
            setHiddenError(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
  const onFailed = (value) => {}

  const modalDelete = () => {
    return (
      <DeleteUnitMeasurment
        visibleDelete={visibleDelete}
        setVisibleDelete={setVisibleDelete}
        state={'unitmeasurment'}
        data={dataEdit}
        renderData={getResultDataUnitMeasurment}
        setVisibleDrawer={setVisible}
      />
    )
  }

  // add unitmeasuement
  const eventAdd = () => {
    form.setFieldsValue({
      unitCode: null,
      localName: null,
      engName: null,
      ABBR: null,
      createBy: infoUser.firstname + ' ' + infoUser.lastname,
      createDate: moment(`${today}`, 'YYYY-MM-DD'),
      lastupdate: moment(`${today}`, 'YYYY-MM-DD'),
    })
    setHiddenError(true)
    setVisible(true)
    setStateDrawer('add')
    setTitleDrawer(' Add Unit Measurement')
  }
  // edit unitmeasurment
  const eventEdit = (data) => {
    permissionPage.update ? setDisablePage(false) : setDisablePage(true)
    form.setFieldsValue({
      unitCode: data.unit_code,
      localName: data.local_name,
      engName: data.english_name,
      ABBR: data.abbr_name,
      createBy: data.data.account_name,
      createDate: moment(`${data.data.created_at}`, 'YYYY-MM-DD'),
      lastupdate: moment(`${data.data.updated_at}`, 'YYYY-MM-DD'),
    })
    setHiddenError(true)
    setDataEdit(data)
    setStateDrawer('edit')
    setTitleDrawer(' Edit Unit Measurement')
    setStatusActive(data.status === 'Active' ? true : false)
    setVisible(true)
  }
  const onClose = (value) => {
    setVisible(false)
  }
  const renderButton_Drawer = () => {
    if (stateDrawer === 'add') {
      return (
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Button className="BTN_Next" onClick={form.submit}>
            {word['Save']}
          </Button>
        </div>
      )
    } else {
      return (
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Button
            hidden={permissionPage.delete ? false : true}
            className="BTN_Delete_CPF_RED"
            onClick={() => setVisibleDelete(true)}
            style={{ marginRight: 8 }}
          >
            {word['Delete']}
          </Button>
          <Button
            hidden={permissionPage.update ? false : true}
            className="BTN_Next"
            onClick={form.submit}
            type="primary"
          >
            {word['Save']}
          </Button>
        </div>
      )
    }
  }

  const content = () => {
    if (dataUnitMeasurment.length > 0) {
      return (
        <ContainerMeasurment>
          <Header className="layout-button-add-normal-state">
            <div className="layout-btn-reset-add">
              <Button
                onClick={eventAdd}
                icon={<PlusOutlined className="Icon-color" />}
                className="BTN_Next"
                hidden={permissionPage.create ? false : true}
              >
                {word['Add_Unit_Measurement']}
              </Button>
              <Button
                type="primary"
                style={{ marginLeft: 8 }}
                className="btn_Secondary2"
                onClick={() => window.location.reload()}
              >
                <RedoOutlined className="Icon-color" />
                {word['Reset']}
              </Button>
            </div>
          </Header>
          <Body lassName="custom-header">
            <div className="custom-header">
              <Table
                className="HEAD_Table"
                key="unitmeasurment"
                onRow={(record) => {
                  return {
                    onClick: () => eventEdit(record), // click row
                  }
                }}
                columns={columns}
                dataSource={dataSource}
                onChange={onChange}
                pagination={pagination}
                showSorterTooltip={false}
              />
            </div>
          </Body>
        </ContainerMeasurment>
      )
    } else {
      return (
        <EmptyContainer className="initialstate-container">
          <img src={iconEmpty} />
          <h2>{word['Please_add_unit_measurement']}</h2>
          <Button
            hidden={permissionPage.create ? false : true}
            onClick={eventAdd}
            icon={<PlusOutlined className="Icon-color" />}
            className="btn_Secondary2"
          >
            {word['add_unit_measurement']}
          </Button>
        </EmptyContainer>
      )
    }
  }
  return (
    <UnitContainer style={{ padding: 32 }} className="layout-git-master-unitmeasurment">
      {content()}
      <Modal
        maskClosable={false}
        title={<TextTitleBold>{titleDrawer}</TextTitleBold>}
        placement="right"
        onCancel={onClose}
        visible={visible}
        footer={renderButton_Drawer()}
        destroyOnClose
        width={'634px'}
        className="fix-modal"
        centered
      >
        <Form
          className="disable-page"
          form={form}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFailed}
        >
          <fieldset disabled={disablePage}>
            <div hidden={hiddenError} style={{ marginBottom: 10 }}>
              <Alert message={wordError} type="error" showIcon />
            </div>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  id="unitCode"
                  name="unitCode"
                  label={<h4>{word['Unit_Code']}</h4>}
                  className="customValidation"
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter unit code',
                    },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="Please enter unit code"
                    maxLength={onChangeUnitCode}
                    onKeyUp={(e) =>
                      form.setFieldsValue({
                        unitCode: toUpper(e.target.value),
                      })
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  id="localName"
                  name="localName"
                  label={<h4>{word['Local_Name']}</h4>}
                  className="customValidation"
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter local name',
                    },
                  ]}
                >
                  <Input size="large" placeholder="Please enter local name" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  id="engName"
                  name="engName"
                  className="customValidation"
                  label={<h4>{word['English_Name']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter english name',
                    },
                  ]}
                >
                  <Input size="large" placeholder="Please enter english name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  id="ABBR"
                  name="ABBR"
                  className="customValidation"
                  label={<h4>{word['ABBR_Name']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter abbr name',
                    },
                  ]}
                >
                  <Input size="large" placeholder="Please enter abbr name" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  id="createBy"
                  name="createBy"
                  label={<h4>{word['Create_by']}</h4>}
                >
                  <Input disabled size="large" placeholder="Create By" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  id="createDate"
                  name="createDate"
                  label={<h4>{word['Create_Date']}</h4>}
                >
                  <DatePicker disabled style={{ width: '100%' }} size="large" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  id="lastupdate"
                  name="lastupdate"
                  label={<h4>{word['Last_Update_Date']}</h4>}
                >
                  <DatePicker
                    disabled
                    style={{ width: '100%' }}
                    size="large"
                    placeholder="Last Update"
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  id="status"
                  name="status"
                  label={<h4>{word['Status_Active']}</h4>}
                >
                  <Switch defaultChecked={statusActive} onChange={setStatusActive} />
                </Form.Item>
              </Col>
            </Row>
          </fieldset>
        </Form>
        {modalDelete()}
      </Modal>
    </UnitContainer>
  )
}
export default Unitmeasurement
